// extracted by mini-css-extract-plugin
export default {"image":"CX-z","loaded":"DX-z"};